export const PATH = {
    MAIN: '/main',
    SKILLS: '/skills',
    PROJECTS: '/projects',
    CONTACT: '/contact'
}

export const ABOUT = {
    NAME: 'Ivan Bichan',
    POSITION: 'FRONT-END DEVELOPER BASED IN #Warsaw',
    PHONE: '+48 571 677 842',
    EMAIL: 'ivanbichanfe@gmail.com'
}

export const LINKS = {
    GITHUB: 'https://github.com/IvanBichan',
    LINKED_IN: 'https://www.linkedin.com/in/ivanbichan/',
    TELEGRAM: 'https://t.me/m_rBIN',
    CODEWARS: 'https://www.codewars.com/users/ivanbichanfe',
    PROJECT_LINKS: {
        SOCIAL_NETWORK_DEMO: 'https://IvanBichan.github.io/socialNetwork',
        SOCIAL_NETWORK_CODE: 'https://github.com/IvanBichan/socialNetwork',
        TODO_DEMO: 'https://IvanBichan.github.io/rtk-todolist',
        TODO_CODE: 'https://github.com/IvanBichan/rtk-todolist',
        CARDS_DEMO: 'https://cards-inky-mu.vercel.app/',
        CARDS_CODE: 'https://github.com/hunzah/Cards',
    }
}

export const EMAIL_SERVICE = {
    serviceID: 'service_6j3dycw',
    templateID: 'template_m14c28t',
    publicKey: 'bTZ1-CSsM0jr42Yo1'
}


